import DatePicker from "../../../ui/DatePicker";
import DayTimePicker from "../../DayTimePicker";
import ReferralSourceField from "../../ReferralSourceField";
import { STATUS_OPTIONS } from "../usePatientForm";

/**
 * ניהול ולו"ז — the old "admin" tab (emergency contact moved to DetailsStep). All optional.
 */
function AdminStep({ form }) {
  const {
    formData,
    handleChange,
    canAccessFinance,
    therapistProfile,
    patientTypes,
    treatmentTypes,
  } = form;

  return (
    <div className="pat-wiz-step-panel" key="step-admin">
      <div className="form-row">
        <div className="form-group">
          <label>סטטוס מטופל</label>
          <select
            value={formData.status}
            onChange={(e) => handleChange("status", e.target.value)}
          >
            {STATUS_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>תאריך הצטרפות</label>
          <DatePicker
            value={formData.joinDate}
            onChange={(e) => handleChange("joinDate", e.target.value)}
          />
        </div>
      </div>

      <div className="form-group">
        <label>איך שמע עלינו?</label>
        <ReferralSourceField
          value={formData.referralSource}
          onChange={(val) => handleChange("referralSource", val)}
          therapistProfile={therapistProfile}
        />
      </div>

      {patientTypes.length > 0 && (
        <div className="form-group">
          <label>סוג מטופל</label>
          <div className="patient-types-selector">
            {patientTypes
              .sort((a, b) => a.order - b.order)
              .map((type) => {
                const isSelected = formData.patientTypeIds?.includes(type.id);
                return (
                  <button
                    key={type.id}
                    type="button"
                    className={`patient-type-chip ${
                      isSelected ? "selected" : ""
                    }`}
                    style={{
                      "--type-color": type.color,
                    }}
                    onClick={() => {
                      const currentIds = formData.patientTypeIds || [];
                      const newIds = isSelected
                        ? currentIds.filter((id) => id !== type.id)
                        : [...currentIds, type.id];
                      handleChange("patientTypeIds", newIds);
                    }}
                  >
                    <span
                      className="type-color-dot"
                      style={{ backgroundColor: type.color }}
                    />
                    {type.label}
                  </button>
                );
              })}
          </div>
        </div>
      )}

      {treatmentTypes.length > 0 && (
        <div className="form-group">
          <label>סוג טיפול ברירת מחדל</label>
          <select
            value={formData.defaultTreatmentTypeId}
            onChange={(e) => handleChange("defaultTreatmentTypeId", e.target.value)}
          >
            <option value="">ללא</option>
            {treatmentTypes.map((t) => (
              <option key={t.id} value={t.id}>
                {t.name}{t.rate != null ? ` (₪${t.rate})` : ""}
              </option>
            ))}
          </select>
          <span className="field-hint">
            ימולא אוטומטית בעת קביעת פגישה למטופל זה
          </span>
        </div>
      )}

      <div className={`form-row ${canAccessFinance ? "three-cols" : "two-cols"}`}>
        {canAccessFinance && (
          <div className="form-group">
            <label>תעריף לטיפול (₪)</label>
            <input
              type="number"
              value={formData.treatmentRate}
              onChange={(e) => handleChange("treatmentRate", e.target.value)}
              placeholder="0"
              min="0"
            />
          </div>
        )}
        <div className="form-group">
          <label>משך טיפול (דקות)</label>
          <input
            type="number"
            value={formData.treatmentDuration}
            onChange={(e) => handleChange("treatmentDuration", e.target.value)}
            placeholder="45"
            min="1"
            step="1"
          />
        </div>
        <div className="form-group">
          <label>תדירות טיפול</label>
          <input
            type="text"
            value={formData.treatmentFrequency}
            onChange={(e) => handleChange("treatmentFrequency", e.target.value)}
            placeholder="פעם בשבוע"
          />
        </div>
      </div>

      <div className="form-group">
        <label>ימים ושעות מועדפים</label>
        <DayTimePicker
          value={formData.preferredSchedule}
          onChange={(schedule) => handleChange("preferredSchedule", schedule)}
        />
      </div>

      <h3 className="section-title">הערות</h3>

      <div className="form-group">
        <label>הערות מנהלתיות</label>
        <input
          type="text"
          value={formData.adminNotes}
          onChange={(e) => handleChange("adminNotes", e.target.value)}
          placeholder="למשל: מתעכב תמיד בתשלום"
        />
      </div>
    </div>
  );
}

export default AdminStep;
